import * as React from 'react'
import { Async } from 'react-select'

import './Select.scss'

interface AutoSuggestProps {
  options: Promise<any[]>
  onChange: (option: any) => void
  placeholder?: string
  searchPromptText?: string
}

const AutoSuggest: React.FC<AutoSuggestProps> = ({
  options,
  placeholder,
  searchPromptText,
  onChange,
}) => {
  const getOptions = (input: string, callback: any) => {
    if (!input) {
      return Promise.resolve([])
    }

    options.then(o => {
      callback(null, { options: o })
    })
  }

  return (
    <Async
      clearable={false}
      backspaceRemoves={false}
      onSelectResetsInput={true}
      arrowRenderer={() => null}
      loadOptions={getOptions}
      {...{ searchPromptText, onChange, placeholder }}
    />
  )
}

export default AutoSuggest
